var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.877 4.64a.434.434 0 0 1 0 .605.402.402 0 0 1-.577 0L5.34 2.18v10.112a.414.414 0 0 1-.41.423.418.418 0 0 1-.414-.423V2.18L1.56 5.245a.409.409 0 0 1-.584 0 .434.434 0 0 1 0-.605L4.638.85c.158-.169.42-.169.578 0l3.661 3.79Z",
    fill: "#4D4F50"
  })));
};
export default SvgArrowUp;